import React, { useState } from "react";

import styles from "../AdminDashboard/PieChart.module.scss";
import AdminTableFilter from "../AdminDashboard/adminTable/AdminTableFilter";
import AdminLineChartFilter from "../AdminDashboard/adminTable/adminLineChart/AdminLineChartFilter";
import AdminInterviewChartFilter from "../AdminDashboard/adminTable/adminInterviews/AdminInterviewChartFilter";
import AdminTable from "../AdminDashboard/adminTable/adminPerformanceChart/AdminTable";
import AdminOverallPie from "../AdminDashboard/adminTable/adminPerformanceChart/AdminOverallPie";
import AdminInterviewChart from "../AdminDashboard/adminTable/adminInterviews/AdminInterviewChart";
import AdminLineChart from "../AdminDashboard/adminTable/adminLineChart/AdminLineChart";
import JoinedRoiWithandWithout from "./joinedROI/JoinedRoiWithandWithout";
import { MyModal } from "../../utility";
import ModalContainer from "../../components/modal_popup";
import { postAdsInvest } from "../../apiServices";
import SuccessTick from "../../components/success_tick";
import InvoiceROI from "./invoiceROI/InvoiceROI";
import AdInvestment from "./adInvestment/AdInvestment";


function RetentionOnInvest() {
  const [chartType, setChartType] = useState("Table");
   const [openModal, setOpenModal] = useState(false);
  // const [successModal, setsuccessModal] = useState(false);
  // const [isSubmitting, setIsSubmitting] = useState(false);

  // const [investData, setInvestData] = useState({
  //   invest_date: "",
  //   platform: "",
  //   amount: "",
  // });

  const handleChartChange = (event) => {
    setChartType(event.target.value);
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setInvestData((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  // };

//  const handleSubmit = async (e) => {
//   e.preventDefault();

//   if (isSubmitting) return; // prevent double click

//   try {
//     setIsSubmitting(true);

//     const { invest_date, platform, amount } = investData;

//     const res = await postAdsInvest({
//       invest_date,
//       platform,
//       amount: Number(amount),
//     });

//     if (res?.status) {
//       setsuccessModal(true);

//       setTimeout(() => {
//         setsuccessModal(false);
//       }, 2000);

//       setOpenModal(false);
//       setInvestData({ invest_date: "", platform: "", amount: "" });
//     }
//   } catch (error) {
//     console.error("Submit error", error);
//   } finally {
//     setIsSubmitting(false); // ✅ ALWAYS re-enable
//   }
// };

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <h4>Admin</h4>
        </div>
        {/* <div> */}
          <div className="d-flex justify-content-center flex-grow-1">
          <div className="d-flex">
               <div className={`me-2 ${styles.radioInput}`}>
              <input
                type="radio"
                name="chartType"
                id="tableViewNo"
                value="Table"
                checked={chartType === "Table"}
                onChange={handleChartChange}
                className="form-check-input"
              />
              <label htmlFor="tableViewNo" className={styles.label}>
              Investments
              </label>
            </div>
            <div className={`me-2 ${styles.radioInput}`}>
              <input
                type="radio"
                name="chartType"
                id="pieChartYes"
                value="Pie"
                checked={chartType === "Pie"}
                onChange={handleChartChange}
                className="form-check-input"
              />
              <label htmlFor="pieChartYes" className={styles.label}>
                Joined ROI
              </label>
            </div>
            <div className={`me-2 ${styles.radioInput}`}>
              <input
                type="radio"
                name="chartType"
                id="lineChartNo"
                value="Line"
                checked={chartType === "Line"}
                onChange={handleChartChange}
                className="form-check-input"
              />
              <label htmlFor="lineChartNo" className={styles.label}>
                Invoice ROI
              </label>
            </div>
           
            {/* <div className={`me-2 ${styles.radioInput}`}>
              <input
                type="radio"
                name="chartType"
                id="InterviewChartNo"
                value="Interview"
                checked={chartType === "Interview"}
                onChange={handleChartChange}
                className="form-check-input"
              />
              <label htmlFor="InterviewChartNo" className={styles.label}>
                Interview
              </label>
            </div> */}
          </div>
          </div>
        {/* </div> */}
        {chartType === "Table" && (
        // <div className="d-flex gap-2 align-items-center">
          <div style={{ minWidth: '120px' }} className="d-flex justify-content-end">
          <button
            className="btn btn-primary"
            onClick={() => {
              setOpenModal(true);
            }}
          >
            Add Investment
          </button>

          {/* {chartType === "Pie" && (
            <div>
              <AdminTableFilter />
            </div>
          )}
          {chartType === "Line" && (
            <div>
              <AdminLineChartFilter />
            </div>
          )}
          {chartType === "Interview" && (
            <div>
              <AdminInterviewChartFilter />
            </div>
          )} */}
        </div>
          )}
      </div>
      <div >
        {chartType === "Pie" && (
          <div className="row">
            <JoinedRoiWithandWithout />
          </div>
        )}
        {chartType === "Line" && (
          <div className="row">
            {/* <div className="col-sm-12"> */}
                <InvoiceROI />
              {/* </div> */}
          </div>
        )}
        {chartType === "Interview" && (
          <div className="row">
            <div className="col-sm-12">
              <div className="container">
                <AdminInterviewChart />
              </div>
            </div>
          </div>
        )}
         {chartType === "Table" && (
          <div className="row">
            {/* <div className="col-sm-12"> */}
              <AdInvestment  openModal={openModal} 
              setOpenModal={setOpenModal}  />
              {/* </div> */}
          </div>
        )}
      </div>
      {/* {openModal && (
        <MyModal>
          <ModalContainer
            childComponent={
              <>
                <form onSubmit={handleSubmit}>
                  <div className="container">
                    <h5 className="mb-3">Add Ads Investment</h5>

                    Date
                    <div className="mb-3">
                      <label className="form-label">Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="invest_date"
                        value={investData.invest_date}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    Platform
                    <div className="mb-3">
                      <label className="form-label">Platform</label>
                      <select
                        className="form-select"
                        name="platform"
                        value={investData.platform}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Platform</option>
                        <option value="Google Ads">Google Ads</option>
                        <option value="Meta Ads">Meta Ads</option>
                      </select>
                    </div>

                    Amount
                    <div className="mb-3">
                      <label className="form-label">Amount</label>
                      <input
                        type="text"
                        className="form-control"
                        name="amount"
                        placeholder="Enter amount"
                        value={investData.amount}
                        required
                        onChange={(e) => {
                          const value = e.target.value;
                          if (/^\d*$/.test(value)) {
                            setInvestData((prev) => ({
                              ...prev,
                              amount: value,
                            }));
                          }
                        }}
                      />
                    </div>

                    Buttons
                    <div className="d-flex justify-content-end gap-2">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setOpenModal(false)}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>

                      <button type="submit" disabled={isSubmitting} className="btn btn-primary">
                      {isSubmitting ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </form>
              </>
            }
          />
        </MyModal>
      )}
      {successModal && (
        <MyModal>
          <ModalContainer
            zIndex={1000}
            childComponent={
              <>
                <SuccessTick HeadText="Successfully!" />
              </>
            }
          />
        </MyModal>
      )} */}
    </div>
  );
}

export default RetentionOnInvest;


